import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonUploadForm } from "../../../Pages/VideoLessons/Ivideolessons";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

type IVideoLesson = VideoLessonUploadForm;

const initialState: IReduxState<IVideoLesson> = {
  data: {} as IAPIResponse<IVideoLesson>,
  isLoading: false,
};

export const AddVideoUploadSlice = createSlice({
  name: "AddVideoUploadSlice",
  initialState,
  reducers: {
    // ✅ Do not store the payload (to avoid serializing File objects)
    addVideoUpload: (state, _action: PayloadAction<VideoLessonUploadForm>) => {
      state.isLoading = true;
    },

    successAddVideoUpload: (state, action: PayloadAction<IAPIResponse<IVideoLesson>>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAddVideoUpload: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddVideoUploadResponse: (state) => {
      state.data = {} as IAPIResponse<IVideoLesson>;
    },
  },
});

export const {
  addVideoUpload,
  successAddVideoUpload,
  failureAddVideoUpload,
  clearAddVideoUploadResponse,
} = AddVideoUploadSlice.actions;

export default AddVideoUploadSlice.reducer;
